import React from 'react';
import PropTypes from 'prop-types';
import styles from './TwoWaySlider.scss';

const TwoWaySlider = props => {
  const {
    width,
    labels,
    step,
    min,
    max,
    initialMin,
    initialMax,
    updateFunction,
    type,
  } = props;
  const [sliderValues, setSliderValues] = React.useState([initialMin, initialMax]);

  React.useEffect(() => {
    if (updateFunction) {
      updateFunction(Math.min(...sliderValues), Math.max(...sliderValues));
    }
  }, [...sliderValues]);

  //reset slider
  React.useEffect(() => {
    if (min == initialMin && max == initialMax && (Math.min(...sliderValues) != min || Math.max(...sliderValues) != max)) {
      setSliderValues([min, max]);
    }
  }, [initialMin,initialMax]);

  const updateSliderValue1 = (e) => {
    const newValue = e.target.value;

    setSliderValues([newValue, sliderValues[1]]);
  };

  const updateSliderValue2 = (e) => {
    const newValue = e.target.value;

    setSliderValues([sliderValues[0], newValue]);
  };

  const stepValues = [];
  for(let i = min; i <= max ; i += step) {
    stepValues.push(i);
  }

  const minValueIndex = stepValues.findIndex((v) => Number(v) === Math.min(...sliderValues));
  const maxValueIndex = stepValues.findIndex((v) => Number(v) === Math.max(...sliderValues));
  const leftPositionPercentage = (minValueIndex / (stepValues.length - 1)) * 100 ;
  const widthPercentage = ((maxValueIndex - minValueIndex) / (stepValues.length - 1)) * 100;
  const activeTrackStyle = {
    left: `${leftPositionPercentage}%`,
    width: `${widthPercentage}%`
  };

  return (
    <div style={{width: width}} >
      <div className={styles.slider}>
        <input className="w-100" type="range" step={step} min={min} max={max} value={sliderValues[0]} onChange={updateSliderValue1}/>
        <input className="w-100" type="range" step={step} min={min} max={max} value={sliderValues[1]} onChange={updateSliderValue2}/>
        <div className={styles.track} />
        <div style={activeTrackStyle}  className={styles.activeTrack} />
        <div className={styles.labels}>
          {labels && labels.map((label, i) => <span key={i} className={(type == 'price' ? 'pr-5 ': null) + styles.label} >{label}</span>)}
        </div>
      </div>
    </div>
  );
};

TwoWaySlider.defaultProps = {
  width: '100%',
  step: 1,
};

TwoWaySlider.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  initialMin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  initialMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  updateFunction: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
  width: PropTypes.string,
  labels: PropTypes.arrayOf(PropTypes.string),
  type: PropTypes.string,
};

export default TwoWaySlider;
